"use client";
import type * as React from "react";
import Avatar from "@mui/material/Avatar";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

export interface Workspace {
    id: "default" | "workspaceB";
    name: string;
    avatar: string;
}
export const workspaces = [
    {
        id: "default",
        name: "Dashboard",
        avatar: "/assets/pulse2.svg",
    },
    {
        id: "workspaceB",
        name: "Verwaltung",
        avatar: "/assets/cloud-gear.svg",
    },
] satisfies Workspace[];

export interface WorkspacesPopoverProps {
	anchorEl: null | Element;
	onChange?: (tenant: string) => void;
	onClose?: () => void;
	open?: boolean;
}

export function WorkspacesPopover({
	anchorEl,
	onChange,
	onClose,
	open = false,
}: WorkspacesPopoverProps): React.JSX.Element {
	return (
		<Menu
			anchorEl={anchorEl}
			anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
			onClose={onClose}
			open={open}
			slotProps={{ paper: { sx: { width: "250px" } } }}
			transformOrigin={{ horizontal: "right", vertical: "top" }}
		>
			{workspaces.map((workspace) => (
				<MenuItem
                    key={workspace.id}
					onClick={() => {
                        onChange?.(workspace.id);
					}}
				>
                    <ListItemAvatar>
                        <Avatar src={workspace.avatar} sx={{ "--Avatar-size": "31px" }} variant="rounded" />
					</ListItemAvatar>
					{workspace.name}
				</MenuItem>
			))}
		</Menu>
	);
}
